if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.cartNotification = document.getElementById('cart-notification');
      this.cartNotificationItem = document.getElementById('cart-notification-item');
      this.multi_item_request = false;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // Check if user has selected all required variants
      if (!this.hasUserSelectedAllVariants()) {
        // On mobile (up to 1023px), navigate to variant picker anchor instead of showing error
        const isMobile = window.innerWidth <= 1023;
        
        if (isMobile) {
          // Find the product-form__buttons anchor - try to get section ID from form ID
          // Handle both main form (product-form-{id}) and sticky bar form (product-form-{id}-product-buy-bar)
          const formId = this.form.getAttribute('id');
          let sectionId = null;
          
          if (formId) {
            // Remove 'product-form-' prefix
            sectionId = formId.replace('product-form-', '');
            // Remove '-product-buy-bar' suffix if present (for sticky bar)
            sectionId = sectionId.replace('-product-buy-bar', '');
          }
          
          const buttonsId = sectionId ? `product-form-buttons-${sectionId}` : null;
          
          if (buttonsId) {
            const buttonsElement = document.getElementById(buttonsId);
            if (buttonsElement) {
              buttonsElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
              return;
            }
          }
          
          // Fallback: try to find buttons container in main form (not sticky bar)
          // Find the main product form (not inside product-buy-bar)
          const mainProductForm = document.querySelector('product-form:not(product-buy-bar product-form)');
          if (mainProductForm) {
            const mainFormButtons = mainProductForm.querySelector('.product-form__buttons');
            if (mainFormButtons) {
              mainFormButtons.scrollIntoView({ behavior: 'smooth', block: 'end' });
              return;
            }
          }
          
          // Last resort: find any product-form__buttons that's not in the sticky bar
          const allButtons = document.querySelectorAll('.product-form__buttons');
          for (const buttons of allButtons) {
            if (!buttons.closest('product-buy-bar')) {
              buttons.scrollIntoView({ behavior: 'smooth', block: 'end' });
              return;
            }
          }
        } else {
          // On desktop, do nothing
          return;
        }
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay')?.classList.remove('hidden');

      // Upsell items handled only in JS
      const upsell_ids_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-id`);
      const upsell_quantities_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-quantity`);
      let upsell_items = [];

      if (upsell_ids_nodes.length !== 0) {
        const upsell_ids = Array.from(upsell_ids_nodes).map(input => parseInt(input.value));
        const upsell_quantities = Array.from(upsell_quantities_nodes).map(input => parseInt(input.value));
        upsell_items = upsell_ids.map((id, index) => ({'id': id,'quantity': upsell_quantities[index]})).filter(item => item.quantity !== 0);
      }

      const config = { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        }
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      // If upsell items added refactor FormData
      if (upsell_items.length > 0) {
        this.multi_item_request = true;
        const items = upsell_items;
        const id = parseInt(formData.get('id'));
        const quantity = parseInt(formData.get('quantity')) || 1;
        const the_product_item = { 'id': id, 'quantity': quantity }

        items.push(the_product_item);
        const itemsData = { 'items': items };

        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(itemsData);
      } else {
        this.multi_item_request = false;
        config.body = formData;
      }

      try {
        const res = await fetch(routes.cart_add_url + '.js', config)
        const responseText = await res.text();
        let json;
        try {
          json = JSON.parse(responseText);
        } catch (parseErr) {
          const rateLimited = res.status === 429 || /verifying your connect/i.test(responseText);
          throw new Error(
            rateLimited
              ? (window.cartStrings?.error || 'Too many requests. Please wait a moment and try again.')
              : (window.cartStrings?.error || 'Unable to add item to cart. Please try again.')
          );
        }

        if (res.status !== 200) throw new Error(json.description || window.cartStrings?.error || 'Unable to add item to cart.');

        if (this.cartNotification) {
          const notificationTemplate = document.importNode(this.cartNotification.content, true);

          if (this.multi_item_request) {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemsAdded;
            let lastElement = json.items.pop();
            json.items.unshift(lastElement);

            json.items.forEach(item => {
              const singleItem = this.createNotificationItem(item);
              notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
            });
          } else {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemAdded;
            const singleItem = this.createNotificationItem(json);
            notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
          }

          if (document.querySelector('.cart-notification')) {
            document.querySelector('.cart-notification').remove();
          }

          document.querySelector('.site-header').appendChild(notificationTemplate);
          const the_notification = document.querySelector('.cart-notification');
          the_notification.querySelector('.notification-close').addEventListener('click', () => {
            the_notification.classList.remove('anim-in');
          });
          setTimeout(() => {
            the_notification.classList.add('anim-in');
          }, 50);
        }

        const event = new CustomEvent('ajaxProduct:added')
        document.dispatchEvent(event)
      } catch(error) {
        this.handleErrorMessage(error?.message || error);
        console.error(error);
      }

      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay').classList.add('hidden');
      this.resetQuantityInput();
    }

    hasUserSelectedAllVariants() {
      // Check if product has variants (if not, always return true)
      const variantSelector = document.querySelector('variant-radios, variant-selects');
      if (!variantSelector) return true; // No variant selector means product has no variants
      
      // Check if currentVariant is set (this means all options are selected)
      // This is the most reliable check as it's set by the variant selector when all options match
      if (variantSelector.currentVariant) {
        return true;
      }
      
      // Fallback: Check if all variant option groups have a selection
      const fieldsets = variantSelector.querySelectorAll('fieldset, .product-form__input');
      if (fieldsets.length === 0) return true; // No variant options means single variant product
      
      // Check if each fieldset/input group has a checked/selected option
      let allSelected = true;
      fieldsets.forEach(fieldset => {
        // For radio buttons
        const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
        // For select dropdowns
        const select = fieldset.querySelector('select');
        
        if (select) {
          // If it's a select dropdown, check if a value is selected
          if (!select.value || select.value === '') {
            allSelected = false;
          }
        } else if (!checkedRadio) {
          // If it's radio buttons, check if one is checked
          allSelected = false;
        }
      });
      
      return allSelected;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || document.querySelector(`.product-form__error-message-wrapper[form="${this.form.getAttribute('id')}"]`)
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    resetQuantityInput() {
      const hidden_quantity_input = document.querySelector('[type=hidden][name=quantity]');
      if (hidden_quantity_input) {
        hidden_quantity_input.value = 1;
      }
    }

    createNotificationItem(product) {
      const notificationItemTemplate = document.importNode(this.cartNotificationItem.content, true);

      const filename = product.image.split('/').pop();
      const lastDotIndex = filename.lastIndexOf('.');
      const newFilename = `${filename.substring(0, lastDotIndex)}_120x${filename.substring(lastDotIndex)}`;
      const url = product.image.replace(filename, newFilename);

      notificationItemTemplate.querySelector('.notification-item-image').setAttribute('src', url);
      notificationItemTemplate.querySelector('.notification-item-image').classList.remove('hide');
      notificationItemTemplate.querySelector('.notification-item-title').textContent = product.product_title;

      product.options_with_values.forEach(item => {
        const row = document.createElement("dl");
        const nameCell = document.createElement("dt");
        const valueCell = document.createElement("dd");

        nameCell.textContent = item.name + ':';
        valueCell.textContent = item.value;

        row.appendChild(nameCell);
        row.appendChild(valueCell);
        notificationItemTemplate.querySelector('.notification-item-details').appendChild(row);
      })

      return notificationItemTemplate;
    }
  });
}

class AddMultiplier extends HTMLElement {
  constructor() {
    super();

    const multiplyButton = this.querySelector('button');
    this.submitEvent = new SubmitEvent("submit", { submitter: multiplyButton });
    this.multiplyBy = parseInt(this.querySelector('[name=multiplied-quantity]').value);
    this.productForm = this.closest('product-form').querySelector('form');
    const formId = this.productForm.getAttribute('id');
    this.quantity_input = document.querySelector(`[name=quantity][form=${ formId }]`);
    multiplyButton.addEventListener('click', this.submitProductForm.bind(this));
  }

  submitProductForm() {
    this.quantity_input.value = this.multiplyBy;
    this.productForm.dispatchEvent(this.submitEvent);
  }
}
customElements.define("add-multiplier", AddMultiplier);
